import { render, staticRenderFns } from "./group-manager.vue?vue&type=template&id=7ad60716&scoped=true&"
import script from "./group-manager.vue?vue&type=script&lang=js&"
export * from "./group-manager.vue?vue&type=script&lang=js&"
import style0 from "./group-manager.vue?vue&type=style&index=0&id=7ad60716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad60716",
  null
  
)

export default component.exports